import * as React from 'react';
import {ToggleBox} from './ToggleBox';
import {Text} from '../../components/common';
import {thinMargins} from '../../constants';
import {Faq} from '../../types';

interface IFaqBox {
  faqs: Faq[];
}

export const FaqBox = ({faqs}: IFaqBox) => {
  return (
    <div className={`gap-5 ${thinMargins} pb-6 lg:pb-10`}>
      <Text
        as="h2"
        variant="LargeTitle"
        className="text-black text-center pb-12">
        FAQs
      </Text>
      {faqs.map((faq, i) => (
        <ToggleBox key={i} title={faq.question} description={faq.answer} />
      ))}
    </div>
  );
};
